import type { BrandRevenueTableDataQuery } from "@src/__generated__/urql-graphql";
import { BrandReportBaseModel } from "@src/components/modules/reports/brand/common/models";

type TBrand = NonNullable<
  BrandRevenueTableDataQuery["brandRevenue"]
>["result"][0];

export class BrandRevenueModel extends BrandReportBaseModel {
  total_invoiced: TBrand["total_invoiced"];
  our_work_billings_for_date_range: TBrand["our_work_billings_for_date_range"];
  filtered_revenue_share: TBrand["filtered_revenue_share"];
  total_revenue_share: TBrand["total_revenue_share"];
  expenses_billings_for_date_range: TBrand["expenses_billings_for_date_range"];
  __subRows: NonNullable<TBrand["brands"]> | undefined;

  constructor(src: TBrand) {
    super(src);
    this.total_invoiced = src.total_invoiced;
    this.our_work_billings_for_date_range =
      src.our_work_billings_for_date_range;
    this.filtered_revenue_share = src.filtered_revenue_share;
    this.total_revenue_share = src.total_revenue_share;
    this.expenses_billings_for_date_range =
      src.expenses_billings_for_date_range;
    this.__subRows = src.brands ?? undefined;
  }
}
